exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-wrapper[data-v-71b5b79e]{--section-padding:70px;overflow-x:hidden;background-color:var(--background-color);padding-top:var(--section-padding);-webkit-transition:-webkit-filter .3s ease-in-out;transition:-webkit-filter .3s ease-in-out;transition:filter .3s ease-in-out;transition:filter .3s ease-in-out,-webkit-filter .3s ease-in-out}@media (min-width:48em) and (max-width:61.99em){.section-wrapper[data-v-71b5b79e]{--section-padding:90px}}@media (min-width:62em){.section-wrapper[data-v-71b5b79e]{--section-padding:125px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71b5b79e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vuejs/frontend/2023-launch/components/AppSection.vue
// module id = B3OL
// module chunks = 4